import React, { useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { IoMdHome } from "react-icons/io";
import {
  Bell,
  CirclePlus,
  MessageCircle,
  Rss,
  Search,
  User2,
} from "lucide-react";
import ModalSearch from "@/components/search/ModalSearch/ModalSearch";
import { useSearchContext } from "@/contexts/SearchContext";
import { useAppSelector } from "@/lib/store/hooks";
import useLang from "@/hooks/useLang";
import { countries } from "@/constants/data";
import ModalLang from "../ModalLang/ModalLang";
import logoCeedow from "../../../../public/logo-ceedow.png";
import Image from "next/image";

const SideBar = () => {
  const router = useRouter();
  const pathname = usePathname();
  const miniLogoCeedow =
    "https://media.licdn.com/dms/image/v2/D4E0BAQFy-cmZYzUV_Q/company-logo_200_200/company-logo_200_200/0/1713780567992?e=2147483647&v=beta&t=je3CjgZRiL08m1NRLZzzP-soIptPOWS5yoG2TXAF_aQ";

  // states modals
  const { openModalSearch, setOpenModalSearch } = useSearchContext();
  const [openModalLang, setOpenModalLang] = useState(false);

  const newNotifs = useAppSelector((state) => state.notifications.isNotRead);

  // lang functionnality
  const { getText } = useLang();
  const menuList = [
    { menu: getText({ id: "home" }), link: "/" },
    { menu: getText({ id: "searchSidebar" }), link: "/" },
    { menu: getText({ id: "messages" }), link: "/inbox" },
    { menu: getText({ id: "notifications" }), link: "/notifications" },
    { menu: getText({ id: "quote" }), link: "/quote" },
    { menu: getText({ id: "profile" }), link: "/profile/me" },
    { menu: "Blog", link: "https://blog.ceedow.world/actualites" },
  ];
  const countryCode = useAppSelector((state) => state.lang.lang);

  const selectedCountry =
    countries.find((country) => country.code === countryCode) || countries[0];

  // change path
  const pathOnMessage = pathname.startsWith("/inbox");
  const pathOnQuote = pathname.startsWith("/quote");
  const pathOnProfile = pathname === "/profile/me";
  const pathOnHome =
    !pathOnMessage &&
    !pathOnQuote &&
    !pathOnProfile &&
    pathname.startsWith("/");

  const changePath = (path: string) => {
    router.push(path);
  };

  const redirectHome = () => {
    router.push("/");
  };

  return (
    <div
      className={`${
        pathOnMessage ? "w-[5.7vw] px-4" : "fixed sm:w-auto lg:w-[18vw] px-4"
      }  hidden sm:flex h-[100vh] flex-col space-y-8 left-0 bg-white ring-1 py-5 lg:py-10  ring-gray-300`}
    >
      {/* LOGO */}
      <div className={`${pathOnMessage && "items-center justify-center"} flex`} onClick={redirectHome}>
        <span
          className={` ${
            pathOnMessage
              ? "hidden lg:flex items-center justify-center text-2xl font-extrabold text-center px-1"
              : "lg:hidden text-2xl font-bold text-center"
          }`}
        >
          <Image
            src={miniLogoCeedow}
            className=" object-contain"
            width={50}
            height={50}
            quality={100}
            alt={"logo"}
            priority
          />
        </span>
        <span
          className={` ${
            pathOnMessage
              ? "hidden"
              : "hidden lg:block text-2xl font-extrabold px-3"
          }`}
        >
          <Image
            src={logoCeedow}
            className=" object-contain"
            width={123}
            height={43}
            quality={100}
            alt={"logo"}
            priority
          />
        </span>
      </div>

      <div className="flex flex-col space-y-2">
        {menuList.map(({ link, menu }, index: number) => (
          <div
            className={`${
              pathOnMessage
                ? "flex items-center justify-center lg:space-x-1"
                : "space-x-0 lg:space-x-3"
            } w-full flex p-3 rounded-lg hover:bg-gray-100 hover:cursor-pointer`}
            key={index}
            onClick={() => {
              if (menu == "Blog") {
                window.open(link, "_blank");
              }
              if (
                menu !== getText({ id: "searchSidebar" }) &&
                menu !== "Blog"
              ) {
                //setOpenModalSearch(true);
                changePath(link);
              } else if (menu === getText({ id: "searchSidebar" })) {
                setOpenModalSearch(true);
              }
            }}
          >
            <span>
              {menu === getText({ id: "home" }) ? (
                <IoMdHome
                  className={`${pathOnHome && "text-secondary"} stroke-[1.6]`}
                  size={25}
                />
              ) : menu === getText({ id: "searchSidebar" }) ? (
                <Search
                  className={`${
                    openModalSearch && "text-secondary"
                  } stroke-[1.55]`}
                  size={25}
                />
              ) : menu === getText({ id: "messages" }) ? (
                <MessageCircle
                  className={`${
                    pathOnMessage && "text-secondary"
                  } stroke-[1.55]`}
                  size={25}
                />
              ) : menu === getText({ id: "notifications" }) ? (
                <span className="relative">
                  {newNotifs > 0 && (
                    <span className="absolute z-20 -left-1 -top-1 w-4 h-4 rounded-full bg-primary text-white text-[9px] flex items-center justify-center text-center">
                      {newNotifs}
                    </span>
                  )}

                  <Bell className={`stroke-[1.55]`} size={25} />
                </span>
              ) : menu === getText({ id: "quote" }) ? (
                <CirclePlus
                  size={25}
                  className={`${pathOnQuote && "text-secondary"} stroke-[1.55]`}
                  absoluteStrokeWidth
                />
              ) : menu === getText({ id: "profile" }) ? (
                <User2
                  size={25}
                  className={`${
                    pathOnProfile && "text-secondary"
                  } stroke-[1.55]`}
                  absoluteStrokeWidth
                />
              ) : menu === "Blog" ? (
                <Rss
                  size={25}
                  className={`stroke-[1.55]`}
                  absoluteStrokeWidth
                />
              ) : null}
            </span>
            {pathOnMessage ? null : (
              <span
                className={` ${pathOnMessage ? "hidden" : "hidden lg:block"}`}
              >
                {menu}
              </span>
            )}
          </div>
        ))}
        <div
          className={`${
            pathOnMessage ? "flex items-center justify-center" : "space-x-3"
          } w-auto flex p-3 rounded-lg hover:bg-gray-200  hover:cursor-pointer`}
          onClick={() => setOpenModalLang(true)}
        >
          <span className="ml-[3px]">{selectedCountry.flag}</span>
          <span className={` ${pathOnMessage ? "hidden" : "hidden lg:block"}`}>
            {getText({ id: "language" })}
          </span>
        </div>
      </div>

      {/* Modal for language */}
      <ModalLang
        openModalLang={openModalLang}
        setOpenModalLang={setOpenModalLang}
      />

      {/* Modal for search artisan */}
      <ModalSearch
        openModalSearch={openModalSearch}
        setOpenModalSearch={setOpenModalSearch}
      />
    </div>
  );
};

export default SideBar;
